// ============================================================
// LUMEIA — Meta Pixel Configuration
// ============================================================
// Single active pixel for the Lumeia brand.
// Replace META_PIXEL_ID below with the new Lumeia pixel ID
// when ready (current value is the existing active pixel).
// ============================================================

const META_PIXEL_ID = '1330870075619374'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false
const firedOnce = new Set<string>()

/**
 * Loads the Meta Pixel script asynchronously and tracks the initial PageView.
 * Idempotent: safe to call multiple times.
 */
export function initMetaPixel(): void {
  if (initialized) return
  if (typeof window === 'undefined') return
  initialized = true

  const w = window as any

  if (!w.fbq) {
    const fbq: any = function (...args: any[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue.push(args)
      }
    }
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []
    w.fbq = fbq
    w._fbq = fbq

    // Inject the Meta Pixel script asynchronously
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
    } else {
      document.head.appendChild(script)
    }
  }

  w.fbq('init', META_PIXEL_ID)
  trackOnce('PageView')
}

/**
 * Tracks an event only once per session to avoid duplicates.
 */
function trackOnce(eventName: string, params?: Record<string, any>): void {
  if (firedOnce.has(eventName)) return
  firedOnce.add(eventName)
  track(eventName, params)
}

/**
 * Fires a Meta Pixel standard event safely.
 */
function track(eventName: string, params?: Record<string, any>): void {
  try {
    const w = window as any
    if (typeof w.fbq === 'function') {
      if (params) {
        w.fbq('track', eventName, params)
      } else {
        w.fbq('track', eventName)
      }
    }
  } catch {
    // Silently fail
  }
}

// Lumeia product parameters
const PRODUCT_PARAMS = {
  content_name: 'LUMEIA — Volvé a ser deseada',
  content_ids: ['lumeia'],
  content_type: 'product',
  value: 14999,
  currency: 'ARS',
}

export function trackViewContent(): void {
  trackOnce('ViewContent', PRODUCT_PARAMS)
}

export function trackAddToCart(): void {
  track('AddToCart', PRODUCT_PARAMS)
}

export function trackInitiateCheckout(): void {
  track('InitiateCheckout', PRODUCT_PARAMS)
}
